// extracted by mini-css-extract-plugin
export default {"dashboard":"MedicationLists_dashboard__NUekm","nothingSelected":"MedicationLists_nothingSelected__1HMMa","h4":"MedicationLists_h4__1H2Kw"};